import { makeStyles } from '@material-ui/core';
import React from 'react';
import AddPatient from '../Header/AddPatient';
import Search from '../Header/Search';

const styles = makeStyles({
    wrapper: {
        display: 'flex',
        flexDirection: 'row-reverse',
        flex: '0 1 55%'
    }
});
const SearchAndAddPatientsHeader = () => {
    const classes = styles();

    return (
        <>
            <div className={classes.wrapper}>
                <AddPatient />
                <Search />
            </div>
        </>
    );
};

export default SearchAndAddPatientsHeader;
